module.exports = __webpack_public_path__ + "static/media/varais-16-copia.87d558ab.jpg";